// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-label {
  display: inline-flex;
  align-items: center;
  width: 152px;
}
.conn-form-label_align_start {
  transform: translateY(5px);
}
.conn-form-label__inner-content {
  width: inherit;
}
.conn-form-label__help-text {
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/Label/Label.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AACI;EACI,0BAAA;AACR;AAEI;EACI,cAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":[".conn-form-label {\n  display: inline-flex;\n  align-items: center;\n  width: 152px;\n}\n.conn-form-label_align_start {\n  transform: translateY(5px);\n}\n.conn-form-label__inner-content {\n  width: inherit;\n}\n.conn-form-label__help-text {\n  margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
